// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d57e693a","239":"e5402b1c","453":"b45f1ed2","455":"cfd56aeb"}[chunkId] + ".chunk.js";
};